/* unplugin-vue-components disabled */import script from "./Sider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sider.vue?vue&type=script&setup=true&lang=ts"

import "./Sider.vue?vue&type=style&index=0&id=d2c27dea&lang=less&scoped=true"
import "./Sider.vue?vue&type=style&index=1&id=d2c27dea&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2c27dea"]])

export default __exports__